import * as React from "react";
import { cx } from "../../../../../styled-system/css";
import { styles } from "./Element.styles";
import { Icon, Icons } from "../../../../elements/Icon";
import { linkStyles } from "../../../../shared/Button/Button.style";

export interface IElementProps {
  name: string;
  tag?: string;
  className?: string;
  onClick?: React.MouseEventHandler;
  url?: string;
}

export function Element({ name, tag, className, url, onClick }: IElementProps) {
  return (
    <li className={cx(styles.element(), className)}>
      <Icon icon={Icons.outlinedCheckmark} className={styles.icon()} />

      {url ? (
        <a href={url} onClick={onClick} className={cx(linkStyles, styles.featureLink())}>
          <span className={styles.itemWrapper()}>{name}</span>
        </a>
      ) : (
        <span className={styles.itemWrapper()}>{name}</span>
      )}

      {tag && <span className={styles.tagName()}>{tag}</span>}
    </li>
  );
}
